export interface NodeInfoI {
  name: string;
  description: string;
}

const NODE_INFO: Record<string, NodeInfoI> = {
  campaign: {
    name: "Workflow Start",
    description:
      "This is where your workflow begins. Choose how it starts: from a contact list, an external event (like a form submission), on a schedule, or manually from chat.",
  },
  ask_question: {
    name: "Ask a Question",
    description:
      "Ask the user a question and wait for their response before continuing.",
  },
  button: {
    name: "Multiple Choice",
    description:
      "Show the user a set of options to choose from. The workflow continues based on their selection.",
  },
  email: {
    name: "Collect Email",
    description: "Ask the user for their email address.",
  },
  phone: {
    name: "Collect Phone Number",
    description: "Ask the user for their phone number.",
  },
  username: {
    name: "Collect Name",
    description: "Ask the user for their name.",
  },
  address: {
    name: "Collect Address",
    description: "Ask the user for their address.",
  },
  result: {
    name: "Calculate",
    description:
      "Run a calculation and save the result for use in later steps.",
  },
  sendMessage: {
    name: "Send a Message",
    description:
      "Send a text message to the user to let them know what's happening.",
  },
  socialData: {
    name: "External Event Trigger",
    description:
      "Start the workflow when an external system sends data — like a form submission, a new order, or a payment event.",
  },
  segment: {
    name: "Contact List",
    description:
      "Run the workflow for a group of contacts — an email list, a CSV upload, or a saved segment.",
  },
  sendEmail: {
    name: "Send Email",
    description:
      "Send an email to a contact. You'll need to connect your email account (Gmail, Outlook, or SMTP) in Settings → Integrations.",
  },
  sendSMS: {
    name: "Send Text Message",
    description:
      "Send an SMS text message to a phone number. Requires a Twilio account connected in Settings → Integrations.",
  },
  hitApi: {
    name: "Connect to a Service",
    description:
      "Connect to an external app or service (like Shopify, HubSpot, Slack, Reddit, or any API). You'll need to add your credentials in Settings → Integrations.",
  },
  delayAction: {
    name: "Wait",
    description:
      "Pause the workflow for a set amount of time before continuing to the next step. Useful for follow-up sequences.",
  },
  pushNotification: {
    name: "Push Notification",
    description:
      "Send a push notification to the user's device. Requires Firebase set up in Settings → Integrations.",
  },
  abTest: {
    name: "A/B Split",
    description:
      "Split contacts into two groups to test different approaches. For example, send half one email and half another to see which performs better.",
  },
  condition: {
    name: "Decision",
    description:
      "Check a condition and route the workflow down different paths. For example: 'If the lead has 50+ employees, go to path A. Otherwise, go to path B.'",
  },
  assignees: {
    name: "Assign to Team Member",
    description: "Assign this contact or task to a specific team member.",
  },
  whatsApp: {
    name: "WhatsApp Message",
    description:
      "Send a WhatsApp message. Requires WhatsApp Business API connected in Settings → Integrations.",
  },
  envoie: {
    name: "Email Template",
    description:
      "Use a pre-designed email template from Envoie to send a formatted email.",
  },
  openai: {
    name: "AI (OpenAI)",
    description:
      "Use AI to generate content, summarize text, classify data, or make decisions. Uses your OpenAI API key.",
  },
  linkedIn: {
    name: "LinkedIn",
    description:
      "Perform LinkedIn actions — visit a profile, send a connection request, or send a message. Requires LinkedIn account connected.",
  },
  liveChat: {
    name: "Live Chat",
    description:
      "Connect to a live chat agent to continue the conversation in real-time.",
  },
  sticky: {
    name: "Note",
    description:
      "Add a note to the workflow for your team. This doesn't affect the workflow — it's just for documentation.",
  },
  unknown: {
    name: "Unknown Step",
    description: "This step type is not recognized.",
  },
  salesForce: {
    name: "Salesforce",
    description:
      "Connect to Salesforce to create leads, update contacts, or sync data. Requires Salesforce connected in Settings → Integrations.",
  },
  approvalGate: {
    name: "Human Approval",
    description:
      "Pause the workflow and send an email notification asking someone to review and approve. The workflow continues down the 'Approved' path or 'Rejected' path based on their decision.",
  },
  reviewLoop: {
    name: "Review Loop",
    description:
      "Pause for batch human review with iterative revision cycles. Reviewers approve, request changes, or exclude items. Only selected items proceed downstream.",
  },
  runCode: {
    name: "Code",
    description:
      "Run JavaScript code to transform data, do math, format text, or any deterministic operation. No external service needed.",
  },
};

export default NODE_INFO;
